import { create } from "zustand";
import type { SessionKey } from "../domain/types";

/** What the workout player should run when it next mounts.
 *  Home sets this before routing to /workout; the player reads and clears it. */
interface PlayerIntent {
  rescue: boolean;
  extraKey: SessionKey | null;
  /** the day's own Steady session, in its short version (ADR-052) */
  short: boolean;
  setRescue: () => void;
  setExtra: (k: SessionKey) => void;
  setShort: () => void;
  clear: () => void;
}

export const usePlayerIntent = create<PlayerIntent>((set) => ({
  rescue: false,
  extraKey: null,
  short: false,
  setRescue: () => set({ rescue: true, extraKey: null, short: false }),
  setExtra: (k) => set({ rescue: false, extraKey: k, short: false }),
  setShort: () => set({ rescue: false, extraKey: null, short: true }),
  clear: () => set({ rescue: false, extraKey: null, short: false }),
}));
